import { Injectable } from "@angular/core";
import { RealtimeTelemetryMessage } from "../../../models/ws/realtimeTelemetry";
import {
  RealtimeSubscriptionHandle,
  RealtimeSubscriptionRequest,
  RealtimeSubscriptionService,
} from "../realtime-subscription.service";

export interface TimeseriesSubscriptionDescriptor extends RealtimeSubscriptionRequest {
  entityType: string;
  entityId: readonly string[];
  keys: readonly string[];
}

export type TimeseriesSubscriptionHandle = RealtimeSubscriptionHandle<
  RealtimeTelemetryMessage,
  TimeseriesSubscriptionDescriptor
>;

@Injectable({
  providedIn: "root",
})
export class TimeseriesWebsocketService extends RealtimeSubscriptionService<
  RealtimeTelemetryMessage,
  TimeseriesSubscriptionDescriptor
> {
  protected readonly PATH = "timeseries";
  protected readonly VERSION = 1;
}
